import { createFileRoute } from '@tanstack/react-router'
import { DesaOverview } from '../../../pages/DesaOverview'

export const Route = createFileRoute('/desa/$slug/overview')({
  component: DesaOverviewPage,
})

function DesaOverviewPage() {
  const { slug } = Route.useParams()
  return <DesaOverview slug={slug} />
}
